var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DownloadFromCloud1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.955 55.175h8.795L37 66.834l-10.75-11.66h8.795V24.879h3.91v30.297zM53.76 20.89h-1.74a14.953 14.953 0 00-4.574-8.796 15.207 15.207 0 00-25.41 8.796H20.24C14.032 20.89 9 25.922 9 32.13c0 6.207 5.032 11.238 11.24 11.238h8.942v-3.752h-8.943a7.496 7.496 0 110-14.982h5.287v-1.818a11.454 11.454 0 0119.302-7.995 11.279 11.279 0 013.548 7.985v1.828h5.287a7.496 7.496 0 110 14.982H44.82v3.752h8.942C59.968 43.368 65 38.337 65 32.13c0-6.207-5.032-11.239-11.24-11.239z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Download_from_cloud  1.8d4edcb2.svg";
export { SvgJ2DownloadFromCloud1 as ReactComponent };